import React from "react";
import {makeStyles} from "@mui/styles";
import {Typography} from "@mui/material";

const HeadElement = ({title}) => {
  const classes = useStyles();
  return (
    <Typography className={classes.userName}>{title}</Typography>
  )
}

const useStyles = makeStyles(() => ({
  userName: {
    fontSize: 24,
    color: "#434146",
    fontWeight: "600",
    lineHeight: "30px",
    letterSpacing: "0.03em",

    "@media (max-width: 859px)": {
      fontSize: 18,
      lineHeight: "20px"
    }
  },
}));

export default HeadElement
